<div class="container">
  <h3 class="headings">Payment Unsuccessful</h3>
  <ngb-alert [type]="isError ? 'danger' : 'info'" [dismissible]="false"
    >The payment {{ isError ? 'failed' : 'has been cancelled' }}</ngb-alert
  >
  <div class="my-5"></div>
</div>
